// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { RadioTokens } from './type';

const radioTokens: RadioTokens = {
  radioGap: 'Spacing-24',
  radioBlockGap: 'Spacing-12',
  radioIconWidth: 'Font-14',
  radioIconGap: 'Spacing-8',
  radioIconBorderWidth: 'Border-2',
  radioIconInnerSize: 'Size-3',
  radioIconBackgroundColor: 'Neutral-fill-1',
  radioIconColor: 'Neutral-border-2',
  radioIconDisabledBackgroundColor: 'Neutral-fill-2',
  radioIconDisabledColor: 'Neutral-border-1',
  radioIconHoverBackgroundColor: 'Neutral-fill-1',
  radioIconHoverColor: 'Neutral-text-3',
  radioIconCheckedBackgroundColor: 'Neutral-fill-1',
  radioIconCheckedColor: 'Brand-6',
  radioIconCheckedDisabledBackgroundColor: 'Neutral-fill-1',
  radioIconCheckedDisabledColor: 'Brand-3',
  radioIconWrapperFill: 'Neutral-fill-2',
  radioIconWrapperDark: 'Neutral-fill-3',
  radioIndicatorMarginTop: 'Spacing-4',
  radioPaddingY: 'Spacing-4',
  radioButtonPaddingY: 'Spacing-4',
  radioButtonPaddingX: 'Spacing-12',
  radioButtonBorderColor: 'Neutral-border-2',
  radioSmallIconWidth: 'Font-12',
  radioSmallIconBorderWidth: 'Border-1',
  radioSmallIconInnerSize: 'Size-3',
  radioSmallLabelFontSize: 'Font-12',
  radioSmallPaddingY: 'Spacing-1',
  radioSmallButtonPaddingY: 'Spacing-1',
  radioSmallButtonPaddingX: 'Spacing-8',
  radioLargeIconWidth: 'Font-16',
  radioLargeIconBorderWidth: 'Border-2',
  radioLargeLabelFontSize: 'Font-16',
  radioLargePaddingY: 'Spacing-7',
  radioLargeButtonPaddingY: 'Spacing-7',
  radioLargeButtonPaddingX: 'Spacing-16',
  radioLabelFontColor: 'Neutral-text-5',
  radioLabelFontSize: 'Font-14',
  radioLabelDisabledFontColor: 'Neutral-text-2',
};

export default radioTokens;
